import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  addData,
  deleteData,
  getList,
  editData,
} from "../../helpers/fackBackend_Helper";

function* addChatrRechargePlanResponse({ payload: { data } }) {
  try {
    const response = yield call(editData, "/rechargePlan", data);
    if (response.response.Status) {
      const responseList = yield call(
        getList,
        `/rechargePlanByNetwork/${data.networkID}`,
      );
      if (responseList.response.Status) {
        yield put(
          actions.addChatrRechargePlanSuccess(
            response.response.PlanBundle.Message,
            responseList.response.Data,
          ),
        );
      } else {
        yield put(
          actions.addChatrRechargePlanFailed(response.response.Message),
        );
      }
    } else {
      yield put(actions.addChatrRechargePlanFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.addChatrRechargePlanFailed(error));
  }
}

function* getChatrRechargePlanListResponse({ networkID }) {
  try {
    const response = yield call(getList, "/rechargePlanByNetwork/" + networkID);
    if (response.response.Status) {
      yield put(
        actions.getChatrRechargePlanDataSuccess(response.response.Data),
      );
    } else {
      yield put(
        actions.getChatrRechargePlanDataFailed(response.response.Message),
      );
    }
  } catch (error) {
    yield put(actions.getChatrRechargePlanDataFailed(error));
  }
}

function* deleteChatrRechargePlanDataResponse({
  payload: { planId, status, networkID },
}) {
  try {
    debugger;
    const response = yield call(
      deleteData,
      "/rechargePlan/" + planId + "/" + status,
    );
    if (response.response.Status) {
      const responseList = yield call(
        getList,
        "/rechargePlanByNetwork/" + networkID,
      );
      if (responseList.response.Status) {
        yield put(
          actions.deleteChatrRechargePlanSuccess(
            response.response.Message,
            responseList.response.Data,
          ),
        );
      } else {
        yield put(
          actions.addChatrRechargePlanFailed(response.response.Message),
        );
      }
    } else {
      yield put(actions.addChatrRechargePlanFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.addChatrRechargePlanFailed(error));
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(actions.ADD_CHATR_RECHARGE_PLAN, addChatrRechargePlanResponse),
    takeEvery(
      actions.GET_CHATR_RECHARGE_PLAN_DATA,
      getChatrRechargePlanListResponse,
    ),
    takeEvery(
      actions.DELETE_CHATR_RECHARGE_PLAN,
      deleteChatrRechargePlanDataResponse,
    ),
  ]);
}
